type PaymentMethodType = {
  brand: string;
  expiryMonth: number;
  expiryYear: number;
  maskedNumber: string;
};

export type { PaymentMethodType };

export const brandName = (brand: string) => {
  switch (brand.toUpperCase()) {
    case 'AMERICAN_EXPRESS':
      return 'American Express';
    case 'DINERS_CLUB':
      return 'Diners Club';
    case 'JCB':
      return 'JCB';
    case 'MASTERCARD':
      return 'MASTERCARD';
    case 'VISA':
      return 'VISA';
  }

  return '不明';
};
